import React, {ReactNode} from 'react';
import WarningText, {WarningTextProps} from './WarningText';
import {Grid} from '@mui/material';

type WarningTextWithTitleProps = WarningTextProps & {
  title: ReactNode | string;
};

const WarningTextWithTitle: React.FC<WarningTextWithTitleProps> = ({title, text, ...props}) => {
  return (
    <Grid container wrap="nowrap" alignItems="flex-start" direction="column" {...props}>
      <Grid>
        <div className="headlineBlue">{title}</div>
      </Grid>
      <WarningText text={text} />
    </Grid>
  );
};

export default WarningTextWithTitle;
